<template>
  <div class="pageContol">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">数据中心</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">重考申请</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">{{ lastPageData.applyId ? '编辑' : '新增' }}</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-form ref="ruleForm" class="ruleForm" :rules="rules" :model="ruleForm" label-width="6.25rem" size="small"
              style="width: 31.25rem;">
              <div class="fromTitle">基本信息</div>
              <el-form-item label="考核日期:" prop="examinationDate">
                <el-date-picker size="small" v-model="ruleForm.examinationDate" type="date" value="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择日期" disabled>
                </el-date-picker>
              </el-form-item>
              <el-form-item label="作业类别:" prop="workCategory">
                <el-select size="small" v-model="ruleForm.workCategory" clearable placeholder="请选择作业类别"
                  :disabled="lastPageData.applyId != ''">
                  <el-option v-for="item in workCategoryList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="考生信息" prop="examinationUserId">
                <el-select v-model="ruleForm.examinationUserId" placeholder="请选择" no-data-text="没有数据" remote
                  size="small" clearable :remote-method="getExamineeInformation"
                  @visible-change="clearExamineeInformation" :disabled="lastPageData.applyId != ''">
                  <template>
                    <div class="select-header">
                      <span style="
                        color: #8492a6;
                        float: left;
                        font-size: .8125rem;
                        width: 6.25rem;
                      ">学员姓名</span>
                      <span style="
                        color: #8492a6;
                        float: left;
                        font-size: .8125rem;
                        margin-left: 3.125rem;
                        width: 8.75rem;
                      ">身份证号码</span>
                    </div>
                    <div class="select-header">
                      <el-input v-model="ruleForm.fullName" v-on:input="getExamineeInformation" type="text" size="small"
                        placeholder="学员姓名" clearable style="width: 6.25rem" />
                      <el-input v-model="ruleForm.idCard" v-on:input="getExamineeInformation" type="text" size="small"
                        placeholder="身份证号码" clearable style="margin-left: 3.125rem; width: 8.75rem" />
                    </div>
                  </template>
                  <el-option v-for="(item, index) in userList" :key="index" :label="item.fullName + '-' + item.idCard"
                    :value="item.examinationUserId">
                    <span style="width: 6.25rem; font-size: .8125rem">{{ item.fullName }}</span>
                    <span style="width: 8.75rem; margin-left: 3.125rem; font-size: .8125rem">{{ item.idCard }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="申请材料" required>
                <!-- multiple -->
                <el-upload class="upload-demo" action drag show-file-list :file-list="ruleForm.applyMaterials"
                  accept=".png,.jpg,.jpeg,.pdf" :on-remove="(el, list) => removeFile(el, list, 1)"
                  :on-preview="previewFile" :http-request="(el) => uploadFile(el, 1)">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    将文件拖到此处，或<em>点击上传</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    只能上传图片或PDF文件，且不超过500kb
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-button class="bgc-bv" @click="$router.back()">取 消</el-button>
                <el-button class="bgc-bv" @click="sureData">确 定</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 上传材料 - 预览 -->
    <el-dialog title="上传材料 - 预览" :visible.sync="formUploadMaterialsPreview.dialogVisible" @close="uploadLodClose"
      :modal="false" width="50%" top="2%" center v-dialogDrag>
      <div class="ovy-a" style="height: 37.5rem">
        <div id="pdf-cert1" style="height: 37.5rem"
          v-if="formUploadMaterialsPreview.fileType == 'pdf' || formUploadMaterialsPreview.fileType == 'PDF'"></div>
        <div v-else>
          <img :src="formUploadMaterialsPreview.materialUrl" alt="" width="100%" height="100%" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pdf from "pdfobject";
import { acceptTypeImg } from "@/utils/common";
export default {
  name: "examinationAffairsManage_reexaminationApplicationAddOrEdit",
  data() {
    return {
      // 上个页面的数据
      lastPageData: {
        applyId: "",  // 重考申请id
      },
      // 基本信息
      ruleForm: {
        examinationDate: new Date(new Date().getTime()).Format('yy-MM-dd'), // 考试日期
        workCategory: "", // 作业类别
        examinationUserId: "", // 考生学员id
        fullName: "", // 考生学员
        idCard: "", // 考生身份证号
        applyMaterials: [], // 申请材料
      },
      // 作业类别 - 下拉数据
      workCategoryList: [],
      // 考生列表
      userList: [],
      // 基本信息 - 数据校验
      rules: {
        examinationDate: [
          { required: true, trigger: "change", message: "请选择考试日期" }
        ],
        workCategory: [
          { required: true, trigger: "change", message: "请选择作业类别" }
        ],
        examinationUserId: [
          { required: true, trigger: "change", message: "请选择考生信息" }
        ],
      },
      // 上传材料 - 预览材料 - 弹框数据
      formUploadMaterialsPreview: {
        dialogVisible: false, // 弹窗状态
        fileType: "", // 文件类型
        materialUrl: "", // 预览图片的地址
      },
    };
  },
  created() {
    this.lastPageData.applyId = this.$route.query?.applyId ?? "";
    this.getDictionary();
    if (this.lastPageData.applyId) {
      this.getDetail();
    }
  },
  watch: {},
  computed: {},
  mounted() { },
  methods: {
    // 获取 - 字典
    getDictionary() {
      // 作业类别
      let workCategory = this.$setDictionary("PA_WORK_CATEGORY", "list");
      for (const key in workCategory) {
        this.workCategoryList.push({
          value: key,
          label: workCategory[key],
        });
      }
    },
    // 获取 - 考生信息
    getExamineeInformation() {
      // 考试日期 && 作业类别 同时选择才可查
      if (this.ruleForm.examinationDate && this.ruleForm.workCategory) {
        this.$post("/biz/plan/pa-plan-examination-user/query/list", {
          pageNum: 1, //每次都只要第一页
          pageSize: 5, //根据次参数控制显示的数据行数，尽量不出现滚动条
          examinationDate: this.ruleForm.examinationDate, // 考试日期
          workCategory: this.ruleForm.workCategory, // 作业类别
          fullName: this.ruleForm.fullName, // 考生姓名
          idCard: this.ruleForm.idCard, // 身份证
        }, 3000, true, 10).then((res) => {
          if (res.data.length) {
            this.userList = res.data;
          } else {
            this.userList = [{}];
          }
          // 编辑 - 手搓一个下拉数据
          if (this.lastPageData.applyId) {
            this.userList = [...this.userList,...[{
              examinationUserId: this.ruleForm.examinationUserId,
              fullName: this.ruleForm.fullName,
              idCard: this.ruleForm.idCard,
            }]]
          }
        });
      } else {
        this.$message.warning("请同时选择：“考试日期” 和 “作业类别”");
      }
    },
    // 清除 - 考生信息
    clearExamineeInformation(e) {
      if (e) {
        this.ruleForm.fullName = "";
        this.ruleForm.idCard = "";
        this.userList = [];
        this.getExamineeInformation();
      }
    },
    // 获取 - 详情
    getDetail() {
      this.$post("/biz/plan/resit/apply/info", {
        applyId: this.lastPageData.applyId
      }, 3000, true, 10).then((res) => {
        for (let i = 0; i < res.data.materialBOS.length; i++) {
          res.data.materialBOS[i].name = res.data.materialBOS[i].materialName;
          res.data.materialBOS[i].url = res.data.materialBOS[i].materialUrl;
        }
        res.data.applyMaterials = res.data.materialBOS;
        delete res.data.materialBOS;
        this.ruleForm = { ...this.ruleForm, ...res.data };
        this.getExamineeInformation();
      });
    },
    // 上传材料 - 上传文件
    uploadFile(res) {
      if (acceptTypeImg(res)) {
        this.$message.error("上传文件的大小不能超过 10MB!");
        return false;
      } else {
        let fileName = res.file.name; // 文件名
        let extension = fileName.replace(/.+\./, ""); // 文件类型
        if (!".png,.jpg,.jpeg,.bmp,.gif,.pdf,.PDF".includes(extension[extension.length - 1])) {
          this.$message.warning({
            message: "只能上传图片与pdf格式的文件！",
            duration: 1000,
          });
          return false;
        }
        let formData = new FormData();
        formData.append("folder ", "PRACTICAL_QUESTION_BANK");
        formData.append("file ", res.file);
        formData.append("fileType", extension);
        formData.append("isPublic", false);

        this.$Postformat("/sys/file/upload/url", formData, 3000, true, 10)
          .then((result) => {
            this.ruleForm.applyMaterials.push({
              materialType: extension,
              materialKey: result.data.fileKey,
              materialUrl: result.data.fileUrl,
              materialName: res.file.name,
              name: res.file.name,
              url: result.data.fileUrl,
            });
          })
          .catch((err) => {
            setTimeout(() => {
              this.$message({
                type: "warning",
                message: "上传失败",
              });
            }, 300);
          });
      }
    },
    // 上传材料 - 删除文件
    removeFile(file, fileList) {
      this.ruleForm.applyMaterials = fileList;
    },
    // 上传材料 - 预览文件
    previewFile(res) {
      let extension = res.materialKey.replace(/.+\./, "");
      this.formUploadMaterialsPreview.fileType = extension;
      if (extension == "pdf" || extension == "PDF") {
        this.$nextTick(() => {
          pdf.embed(res.materialUrl, "#pdf-cert1");
        });
      } else {
        this.formUploadMaterialsPreview.materialUrl = res.materialUrl;
      }
      this.formUploadMaterialsPreview.dialogVisible = true;
    },
    // 上传材料 - 关闭弹窗
    closeUploadMaterials() {
      this.formUploadMaterials = this.$options.data().formUploadMaterials;
    },
    // 保存 - 新增&编辑
    sureData() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.applyMaterials.length) {
            this.$message.warning("请上传申请材料");
            return
          }
          let cData = {
            ...this.ruleForm,
          }
          let url = '';
          if (this.lastPageData.applyId) {
            url = '/biz/plan/resit/apply/modify';
            cData.applyId = this.lastPageData.applyId;
          } else {
            url = '/biz/plan/resit/apply/save'
          }
          this.$post(url, cData, 3000, true, 10)
            .then((res) => {
              this.$message.success('操作成功')
              this.$router.back();
            })
            .catch((err) => {
              return;
            });
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
.select-header {
  font-size: .875rem;
  padding: 0 1.25rem;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: 2.125rem;
  line-height: 2.125rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}

.ruleForm {
  .fromTitle {
    font-size: 1.125rem;
    margin-bottom: 1.25rem;
  }
}
</style>